document.addEventListener("DOMContentLoaded", function () {
  // Use a unique container to avoid conflicts if multiple footers exist
  const footer = document.querySelector("footer.footer");
  if (!footer) return;

  const headings = footer.querySelectorAll(".footer-block__heading");

  function setupMobileAccordion() {
    const isMobile = window.innerWidth < 749;

    headings.forEach(heading => {
      const content = heading.nextElementSibling;

      // Remove old listener to prevent duplicates
      heading.removeEventListener("click", toggleAccordion);

      if (isMobile) {
        // Mobile: collapsible
        heading.style.cursor = "pointer";
        heading.setAttribute("aria-expanded", "false");

        if (content && content.classList.contains("footer-block__details-content")) {
          content.style.overflow = "hidden";
          content.style.transition = "max-height 0.35s ease";
          // Only set initial closed state once
          if (!content.dataset.accordionInit) {
            content.style.maxHeight = "0px";
            content.dataset.accordionInit = "true";
          }
        }

        heading.addEventListener("click", toggleAccordion);
      } else {
        // Desktop: always open
        heading.style.cursor = "default";
        heading.setAttribute("aria-expanded", "true");

        if (content) {
          content.style.maxHeight = "none";
        }
      }
    });
  }

  function toggleAccordion(e) {
    e.preventDefault();
    const content = this.nextElementSibling;
    if (!content) return;

    const isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

    if (isOpen) {
      content.style.maxHeight = "0px";
      this.classList.remove("active");
      this.setAttribute("aria-expanded", "false");
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      this.classList.add("active");
      this.setAttribute("aria-expanded", "true");
    }
  }

  // Run on load
  setupMobileAccordion();

  // Re-run on resize with debounce
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupMobileAccordion, 100);
  });
});